import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { UDFText, UDFCheckBox, UDFDateTime, UDFNumber, UDFSelect } from '../InputControls'

const useStyles = makeStyles(theme => ({

}));

const UDFDataField = (props) => {

    const GetDataField = (type, UDF, props) => {

        switch (type) {
            case "Text": {
                if (UDF.Picklist && UDF.Picklist.length > 0) {
                    return <UDFSelect UDF={UDF} {...props}></UDFSelect>
                }
                return <UDFText UDF={UDF}  {...props}></UDFText>
            }
            case "Bit": {
                return <UDFCheckBox UDF={UDF} {...props}></UDFCheckBox>
            }
            case "Date": {
                return <UDFDateTime UDF={UDF} {...props}></UDFDateTime>
            }
            case "Decimal": {
                return <UDFNumber UDF={UDF} {...props}></UDFNumber>
            }
            case "Picklist": {
                return <UDFSelect UDF={UDF} {...props}></UDFSelect>
            }
        }
    }

    return (
        GetDataField(props.udf.UDFType, props.udf, props)
    );
};

export default UDFDataField;
